import React from "react";
import { useConfiguratorContext } from "@studio3dx/legacy-use-configurator/react";
import { ListDisplay } from "./ListDisplay";
import { CardDisplay } from "./CardDisplay";
import { RowDisplay } from "./RowDisplay";
import { DefaultDisplay } from "./DefaultDisplay";

interface SectionRendererProps {
  section: any;
}

export const SectionRenderer: React.FC<SectionRendererProps> = ({
  section,
}) => {
  const configurator = useConfiguratorContext();
  const displayStyle = section?.metadata?.uiDisplayStyle;

  const getSectionOptions = (section: any) => {
    if (section?.metadata?.showAllOptions) {
      return configurator.getAllOptions(section.id);
    } else {
      return configurator.getAvailableOptions(section.id);
    }
  };

  const options = getSectionOptions(section);

  const commonProps = {
    options,
    section,
  };

  switch (displayStyle) {
    case "list":
      return <ListDisplay {...commonProps} />;
    case "card":
      return <CardDisplay {...commonProps} />;
    case "row":
      return <RowDisplay {...commonProps} />;
    default:
      return <DefaultDisplay {...commonProps} />;
  }
};
